<template>
  <div class="mk">
    <div v-wechat-title="$route.meta.title"></div>

    <!-- <div class="diandi"></div> -->
    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd bxz">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>

      </div>
    </div>
    <div class="lbBox">
      <div class="lbBoxtext">
        <div class="lbBoxtexts lbBoxtexts1">
            米咖 为新零售企业插上翅膀
        </div>
        <div class="lbBoxtexts lbBoxtexts2">
            <div>免费工具赋能营销</div>
            <div>1折爆品供应连</div>
            <div>精准到店引流</div>
        </div>
      </div>
    </div>
    <div class="shipinboxbox">
        <div class="shipinbox">
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg1"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>

            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg2"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg3"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg4"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg5"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg6"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg7"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
            <div @click="mkxq" class="shipins">
                <div class="shipinsimg shipinsimg8"></div>
                <div class="shipinstext1">1钜惠某木门·衣柜店活动案例动案例木门</div>
                <div class="shipinstext2">2021 - 10 - 09</div>
            </div>
        </div>
    </div>

    <div class="tijiaoboxbox">
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/service/common.service.js";
export default {
  data() {
    //

    return {
      name1: "name1",
      name2: "name2",
      name3: "name3",
      name4: "name4",
      hsk:1,

    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    mkxq(){
      this.$router.push({
        path: "/mkxq",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
    // 提交数据接口
  },
};
</script>

<style lang="scss">
.mk {
  font-size: 0.16rem;
  background: #fff;
    .dhtBox{
    .bxz{
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1594.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2rem;
    box-sizing: border-box;
    .lbBoxtext{
      width: 1200px;
      margin: 0 auto;
      .lbBoxtexts{
        text-align: center;
      }
      .lbBoxtexts1{
        font-size: 0.60rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 0.67rem;
      }

      .lbBoxtexts2{
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFEFE;
        line-height: 0.38rem;
        margin-bottom: 0.1rem;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 800px;
        margin: 0 auto;
      }
    }
  }
.shipinboxbox{
    width: 100%;
    background: #fff;
    .shipinbox{
        width: 1200px;
        margin: 0 auto;
        padding-top: 0.5rem;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0.6rem;
        .shipins{
            width: 2.78rem;
            margin-right: 0.29rem;
            .shipinsimg{
                width: 2.78rem;
                height: 1.78rem;
                background-size: 100% 100%;
                margin-bottom: 0.1rem;
            }
            .shipinsimg1{
                background: url('../../assets/images/s1.png') no-repeat center;
            }
            .shipinsimg2{
                background: url('../../assets/images/s2.png') no-repeat center;
            }
            .shipinsimg3{
                background: url('../../assets/images/s3.png') no-repeat center;
            }
            .shipinsimg4{
                background: url('../../assets/images/s4.png') no-repeat center;
            }
            .shipinsimg5{
                background: url('../../assets/images/s5.png') no-repeat center;
            }
            .shipinsimg6{
                background: url('../../assets/images/s6.png') no-repeat center;
            }
            .shipinsimg7{
                background: url('../../assets/images/s7.png') no-repeat center;
            }
            .shipinsimg8{
                background: url('../../assets/images/s8.png') no-repeat center;
            }
            .shipinstext1{
                font-size: 0.18rem;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #121212;
                line-height: 0.30rem;
                 text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
            }
            .shipinstext2{
                font-size: 0.14rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #9B9A9A;
                line-height: 0.30rem;
                text-align: right;
            }
        }
        .shipins:nth-child(4n){
            margin-right: 0;
        }
    }
}









  .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      height: 4.64rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/mk/index.vue